import React from 'react';
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon.js';
import { BlockType } from '../../types/index.js';
import { CollectionMenuBlock as Component } from './Block.js';
import { CollectionMenuBlockSettings as Settings } from './Settings.js';
import { CollectionMenuViewStyle } from './types.js';
export const RegisteredCollectionMenuBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'CollectionMenu',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.CollectionMenu.DisplayName',
                defaultMessage: 'Collections Menu',
            }),
            Settings,
            Icon: React.createElement(ViewGridIcon, null),
            defaultProps: {
                items: [],
                viewStyle: CollectionMenuViewStyle.Collapsible,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map